import {
  ScrollTrigger
} from "./chunk.SY5TJF72.js";
import {
  gsapWithCSS
} from "./chunk.MDJ4MKC6.js";
import {
  jb_campaign_page_hero_fullscreen_css_default
} from "./chunk.SP7354EW.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.534YP5ZJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-campaign-page-hero-fullscreen/jb-campaign-page-hero-fullscreen.ts
var JbCampaignPageHeroFullscreen = class extends i {
  firstUpdated() {
    gsapWithCSS.registerPlugin(ScrollTrigger);
    gsapWithCSS.to(this._inner, {
      scrollTrigger: {
        trigger: this._detector,
        scrub: 0,
        start: "top bottom",
        end: "+=50%"
      },
      yoyo: true,
      opacity: 0,
      scale: 0.8
    });
  }
  _renderHeroImage() {
    if (this.videoSrc) {
      return b`<jb-video
        class="background"
        .src=${this.videoSrc}
        isBackground
      ></jb-video>`;
    }
    return b`<div
        class="background background--desktop"
        style="background-image: url('${this.image}');"
      ></div>
      <div
        class="background background--mobile"
        style="background-image: url('${this.mobileImage}');"
      ></div>`;
  }
  _scrollToContent() {
    window.scrollBy({ top: window.innerHeight, left: 0, behavior: "smooth" });
  }
  _tracking(e2) {
    if (e2.detail.type === "download") {
      const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
        component_name: "campaign-page-hero-fullscreen"
      });
      if (jbTrackingEvent) this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return b`<section>
      <div class="part1">
        ${this._renderHeroImage()}
        <div class="inner">
          <div class="cta">
            ${this.headline ? b`<jb-heading
                    rank="1"
                    variant="title-overview"
                    @click=${this._scrollToContent}
                    >${this.headline}</jb-heading
                  >` : A}
            ${this.text ? b`<p>${this.text}</p>` : A}
            ${this.buttons ? b`<div class="buttons">
                    ${this.buttons.map(
      (button) => b`<jb-button-primary
                          .inverted=${true}
                          @jb-link:clicked=${this._tracking}
                          .link=${button.link}
                          text="${button.text}"
                        ></jb-button-primary>`
    )}
                  </div>` : A}
          </div>
        </div>
      </div>
    </section><div id="detector"></div></div>`;
  }
};
JbCampaignPageHeroFullscreen.styles = [reset_css_default, jb_campaign_page_hero_fullscreen_css_default];
__decorateClass([
  n({ type: Array })
], JbCampaignPageHeroFullscreen.prototype, "buttons", 2);
__decorateClass([
  n({ reflect: true })
], JbCampaignPageHeroFullscreen.prototype, "headline", 2);
__decorateClass([
  n()
], JbCampaignPageHeroFullscreen.prototype, "image", 2);
__decorateClass([
  n()
], JbCampaignPageHeroFullscreen.prototype, "mobileImage", 2);
__decorateClass([
  n()
], JbCampaignPageHeroFullscreen.prototype, "text", 2);
__decorateClass([
  n()
], JbCampaignPageHeroFullscreen.prototype, "videoSrc", 2);
__decorateClass([
  e("#detector")
], JbCampaignPageHeroFullscreen.prototype, "_detector", 2);
__decorateClass([
  e(".inner")
], JbCampaignPageHeroFullscreen.prototype, "_inner", 2);
JbCampaignPageHeroFullscreen = __decorateClass([
  customElement("jb-campaign-page-hero-fullscreen")
], JbCampaignPageHeroFullscreen);

export {
  JbCampaignPageHeroFullscreen
};
